import { ReactComponent as GraphArrowIncrease } from "assets/svg/graph-arrow-increase.svg";
import { ReactComponent as GraphArrowDecrease } from "assets/svg/graph-arrow-decrease.svg";

import { NullableNumber, ReportItemType } from "types/Reports";
import { REPORT_SENSOR_REGISTRY } from "constant/report";

import { formatValuePercentInReport } from "./utils/reportFormat";
import { getPercentDirection, getPercentSubText } from "./utils/reportString";

type ReportPercentTextProps = {
    percent: NullableNumber;
    itemType: ReportItemType;
};

export default function ReportPercentText({
    percent,
    itemType,
}: Readonly<ReportPercentTextProps>) {
    if (percent === null || percent === 0) {
        return <section className="report-percent-text report-percent-text--top"></section>;
    }

    const direction = getPercentDirection(percent);
    const percentDisplay = formatValuePercentInReport(percent);
    const Icon = percent > 0 ? <GraphArrowIncrease width="16px" height="16px" />
        : <GraphArrowDecrease width="16px" height="16px" />;
    const subject = REPORT_SENSOR_REGISTRY[itemType].percentSubject;

    const increaseText = itemType === 'waterLeakage' ? '' : `${subject} ${direction} by `;
    const subText = ` ${getPercentSubText(itemType, direction)}`;

    return <section className="report-percent-text report-percent-text--top">
        {Icon}
        <p>
            {increaseText}
            <span className="report-percent-text-hl">{`${percentDisplay}%`}</span>
            {subText}
        </p>
    </section>;
}
